/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/naming-convention */
import { Dictionary, ToolUrls } from '@warema/shared/models';

export const waremaComToolOverviewUrl: Dictionary<string> = {
    de: 'https://www.warema.com/de-{{ country }}/sonnenschutz/',
    en: 'https://www.warema.com/en/sun-shading-solutions/',
    fr: 'https://www.warema.com/fr-{{ country }}/solutions-de-protection-solaire/',
    nl: 'https://www.warema.com/nl-{{ country }}/zonweringsoplossingen/',
};

export const toolDevUrls: ToolUrls = {
    'warema-plus': 'https://plus-dev.warema.com',
    'warema-designer-web': 'https://configurator-dev.warema.com',
    'warema-collection-assistant': 'https://collection-dev.warema.com',
    'dealer-search': 'https://partners-dev.warema.com',
    'warema-com': 'https://www.warema.com',
};

export const toolTestUrls: ToolUrls = {
    'warema-plus': 'https://plus-test.warema.com',
    'warema-designer-web': 'https://configurator-test.warema.com',
    'warema-collection-assistant': 'https://collection-test.warema.com',
    'dealer-search': 'https://partners-test.warema.com',
    'warema-com': 'https://www.warema.com',
};

export const toolProdUrls: ToolUrls = {
    'warema-plus': 'https://plus.warema.com',
    'warema-designer-web': 'https://configurator.warema.com',
    'warema-collection-assistant': 'https://collection.warema.com',
    'dealer-search': 'https://partners.warema.com',
    'warema-com': 'https://www.warema.com',
};

export const toolLocalhostUrls: ToolUrls = {
    'warema-plus': 'http://localhost:4201',
    'warema-designer-web': 'http://localhost:4203',
    'warema-collection-assistant': 'http://localhost:4204',
    'dealer-search': 'http://localhost:4206',
    'warema-com': 'https://www.warema.com',
};

export const googleMapsApiKeys = {
    prod: 'AIzaSyBb1ni3yNbMUTRqWYbyVkhosK1fCmV8IYU',
    test: 'AIzaSyD1j_IqEPWDhYsjLcxu-XswxTl6FDv7lkw',
    dev: 'AIzaSyB8mNdKhhL2p0Y_Npa4RVlYaVCabQoMCMw',
};
